export const TOKEN_KEY = 'access_token'
export const REFRESH_TOKEN_KEY = 'refresh_token'

export const ORGANISATION_ID = 'organisation_id'

export const QUESTIONTYPE = 'question_type'
export const QUESTIONLIST = 'question_list'
